const DEFAULT_ALLOWED_HOSTNAME = 'app.paybesty.com'

function parseAllowedHostnames(raw: string | undefined | null): string[] {
  return String(raw ?? '')
    .split(',')
    .map((h) => h.trim())
    .filter(Boolean)
}

function normalizeAllowedHosts(hosts: string[]): string[] {
  // Aceita:
  // - hostname: "localhost"
  // - host com porta: "localhost:5174"
  // - URL completa: "https://app.paybesty.com"
  const out = new Set<string>()

  for (const entry of hosts) {
    if (!entry) continue
    const raw = entry.trim()
    if (!raw) continue

    out.add(raw)

    // Se for URL completa, extrai hostname/host
    if (/^https?:\/\//i.test(raw)) {
      try {
        const u = new URL(raw)
        if (u.host) out.add(u.host)
        if (u.hostname) out.add(u.hostname)
      } catch {
        // ignore
      }
    }

    // Se vier com porta, adiciona só o hostname
    const [hostOnly] = raw.split('/')
    const hostnameOnly = hostOnly.split(':')[0]
    if (hostnameOnly) out.add(hostnameOnly)
  }

  return Array.from(out)
}

export const isMarketplaceEnabled = (() => {
  if (typeof window === 'undefined') return false

  const allowedList = parseAllowedHostnames(
    import.meta.env.VITE_MARKETPLACE_ALLOWED_HOSTNAMES,
  )
  const allowedSingle = String(
    import.meta.env.VITE_MARKETPLACE_ALLOWED_HOSTNAME ?? '',
  ).trim()

  const allowed = [
    ...allowedList,
    ...(allowedSingle ? [allowedSingle] : []),
  ]

  // Fallback para o comportamento atual, caso não exista env configurada.
  if (allowed.length === 0) allowed.push(DEFAULT_ALLOWED_HOSTNAME)

  const normalizedAllowed = normalizeAllowedHosts(allowed)

  // hostname: "localhost" | host: "localhost:5174"
  return (
    normalizedAllowed.includes(window.location.hostname) ||
    normalizedAllowed.includes(window.location.host)
  )
})()
